import React from "react";
import {
  DocInfoContainer,
  DocInfoText,
  IconsContainer,
  PostUploadBox,
  ProgressBar,
  ProgressBarContainer,
} from "./DocumentPart.styles";
import { CancelFileIcon, DocumentIcon, DownloadFileIcon } from "../../../../utils/Icons/Part/Document";

interface PostUploadComponentProps {
  uploadProgress: number;
  fileName: string;
  fileSize: number;
  url: string;
  onCancelUpload: () => void;
}
export const PostUploadComponent: React.FC<PostUploadComponentProps> = props => {
  const { uploadProgress, fileName, fileSize, url, onCancelUpload } = props;

  const handleDownloadFile = () => window.open(url, "_blank");

  return (
    <PostUploadBox data-testid="post-upload">
      <IconsContainer>
        <a onClick={handleDownloadFile}>
          <DownloadFileIcon />
        </a>
        <a onClick={onCancelUpload}>
          <CancelFileIcon />
        </a>
      </IconsContainer>
      <DocInfoContainer>
        <DocumentIcon />
        <DocInfoText>
          {fileName} {"\n"}
          {Number((fileSize / 1000000).toFixed(2))} MB
        </DocInfoText>
      </DocInfoContainer>
      <ProgressBarContainer>
        <ProgressBar value={uploadProgress} max={100} />
        {uploadProgress}%
      </ProgressBarContainer>
    </PostUploadBox>
  );
};
